<template>
  <div>
    <div class="tw-flex tw-items-center tw-justify-between">
      <div class="tw-text-gray-800 tw-font-normal">Notes</div>
      <base-button type="text" color="primary" @click="showModal">+ Add Note</base-button>
    </div>
    <div class="tw-mt-2">
      <div v-for="note in orderedNotes" :key="note.id" class="tw-flex-col tw-mb-3">
        <div class="tw-flex">
          <div class="tw-text-gray-500 tw-text-xs tw-font-semibold">{{ note.insertByName }}</div>
          <div class="tw-text-gray-500 tw-text-xs tw-ml-2">{{ formatDate(note.insertDate) }}</div>
        </div>
        <div class="tw-text-gray-800 tw-text-sm">{{ note.noteText }}</div>
      </div>
    </div>
    <business-member-prescription-create-note
      ref="createNote"
      :businessId="businessId"
      :userId="userId"
      :businessPrescriptionId="businessPrescriptionId"
      @updated="$emit('updated')"
    />
  </div>
</template>

<script>
import { orderBy } from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import BusinessMemberPrescriptionCreateNote from "@/views/business/member/prescriptions/components/BusinessMemberPrescriptionCreateNote";

export default {
  components: { BusinessMemberPrescriptionCreateNote },
  props: {
    notes: Array,
    userId: String,
    businessId: String,
    businessPrescriptionId: String,
  },
  data() {
    return {
      isLoading: false,
      newNote: "",
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    orderedNotes() {
      return orderBy(this.notes, ["insertDate"], ["desc"]);
    },
  },
  methods: {
    formatDate(date) {
      return new moment.utc(date).local().format("MM/DD/YYYY hh:mm a");
    },
    showModal() {
      this.$refs.createNote.show();
    },
  },
};
</script>
